
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import { IFlexMessageButton } from '@/utils/types'

@Options({
  components: {},
  directives: { maska },
  emits: ['onSelectNode', 'initListNode'],
})
export default class Button extends Vue {
  @Prop()
  button!: IFlexMessageButton

  @Prop()
  parentLayout!: string

  @Prop()
  direction!: string

  @Prop()
  parentPath!: string

  @Prop()
  hoverPath!: string

  @Prop()
  editPath!: string

  @Prop()
  isAdmin!: boolean

  get marginClass() {
    if (this.parentLayout === 'horizontal' || this.parentLayout === 'baseline') {
      if (this.direction === 'rtl') {
        if (this.button.margin === 'none') {
          return 'ExMgnRNone'
        } else if (this.button.margin === 'xs') {
          return 'ExMgnRXs'
        } else if (this.button.margin === 'sm') {
          return 'ExMgnRSm'
        } else if (this.button.margin === 'md') {
          return 'ExMgnRMd'
        } else if (this.button.margin === 'lg') {
          return 'ExMgnRLg'
        } else if (this.button.margin === 'xl') {
          return 'ExMgnRXl'
        } else if (this.button.margin === 'xxl') {
          return 'ExMgnRXXl'
        }
      } else {
        if (this.button.margin === 'none') {
          return 'ExMgnLNone'
        } else if (this.button.margin === 'xs') {
          return 'ExMgnLXs'
        } else if (this.button.margin === 'sm') {
          return 'ExMgnLSm'
        } else if (this.button.margin === 'md') {
          return 'ExMgnLMd'
        } else if (this.button.margin === 'lg') {
          return 'ExMgnLLg'
        } else if (this.button.margin === 'xl') {
          return 'ExMgnLXl'
        } else if (this.button.margin === 'xxl') {
          return 'ExMgnLXXl'
        }
      }
    } else {
      if (this.button.margin === 'none') {
        return 'ExMgnTNone'
      } else if (this.button.margin === 'xs') {
        return 'ExMgnTXs'
      } else if (this.button.margin === 'sm') {
        return 'ExMgnTSm'
      } else if (this.button.margin === 'md') {
        return 'ExMgnTMd'
      } else if (this.button.margin === 'lg') {
        return 'ExMgnTLg'
      } else if (this.button.margin === 'xl') {
        return 'ExMgnTXl'
      } else if (this.button.margin === 'xxl') {
        return 'ExMgnTXXl'
      }
    }
  }

  get heightClass() {
    if (this.button.height === 'sm') {
      return 'ExSm'
    }
    return ''
  }

  get styleClass() {
    if (this.button.style === 'primary') {
      return 'ExBtn1'
    } else if (this.button.style === 'secondary') {
      return 'ExBtn2'
    }
    return 'ExBtnL'
  }

  get gravityClass() {
    if (this.button.gravity === 'bottom') {
      return 'grvB'
    } else if (this.button.gravity === 'center') {
      return 'grvC'
    }
    return ''
  }

  get offsetTopClass() {
    if (this.button.offsetTop === 'none') {
      return 'ExTNone'
    } else if (this.button.offsetTop === 'xs') {
      return 'ExTXs'
    } else if (this.button.offsetTop === 'sm') {
      return 'ExTSm'
    } else if (this.button.offsetTop === 'md') {
      return 'ExTMd'
    } else if (this.button.offsetTop === 'lg') {
      return 'ExTLg'
    } else if (this.button.offsetTop === 'xl') {
      return 'ExTXl'
    } else if (this.button.offsetTop === 'xxl') {
      return 'ExTXXl'
    } else {
      return ''
    }
  }

  get offsetBottomClass() {
    if (this.button.offsetBottom === 'none') {
      return 'ExBNone'
    } else if (this.button.offsetBottom === 'xs') {
      return 'ExBXs'
    } else if (this.button.offsetBottom === 'sm') {
      return 'ExBSm'
    } else if (this.button.offsetBottom === 'md') {
      return 'ExBMd'
    } else if (this.button.offsetBottom === 'lg') {
      return 'ExBLg'
    } else if (this.button.offsetBottom === 'xl') {
      return 'ExBXl'
    } else if (this.button.offsetBottom === 'xxl') {
      return 'ExBXXl'
    } else {
      return ''
    }
  }

  get offsetStartClass() {
    if (this.direction === 'rtl') {
      if (this.button.offsetStart === 'none') {
        return 'ExRNone'
      } else if (this.button.offsetStart === 'xs') {
        return 'ExRXs'
      } else if (this.button.offsetStart === 'sm') {
        return 'ExRSm'
      } else if (this.button.offsetStart === 'md') {
        return 'ExRMd'
      } else if (this.button.offsetStart === 'lg') {
        return 'ExRLg'
      } else if (this.button.offsetStart === 'xl') {
        return 'ExRXl'
      } else if (this.button.offsetStart === 'xxl') {
        return 'ExRXXl'
      } else {
        return ''
      }
    } else {
      if (this.button.offsetStart === 'none') {
        return 'ExLNone'
      } else if (this.button.offsetStart === 'xs') {
        return 'ExLXs'
      } else if (this.button.offsetStart === 'sm') {
        return 'ExLSm'
      } else if (this.button.offsetStart === 'md') {
        return 'ExLMd'
      } else if (this.button.offsetStart === 'lg') {
        return 'ExLLg'
      } else if (this.button.offsetStart === 'xl') {
        return 'ExLXl'
      } else if (this.button.offsetStart === 'xxl') {
        return 'ExLXXl'
      } else {
        return ''
      }
    }
  }

  get offsetEndClass() {
    if (this.direction === 'rtl') {
      if (this.button.offsetEnd === 'none') {
        return 'ExLNone'
      } else if (this.button.offsetEnd === 'xs') {
        return 'ExLXs'
      } else if (this.button.offsetEnd === 'sm') {
        return 'ExLSm'
      } else if (this.button.offsetEnd === 'md') {
        return 'ExLMd'
      } else if (this.button.offsetEnd === 'lg') {
        return 'ExLLg'
      } else if (this.button.offsetEnd === 'xl') {
        return 'ExLXl'
      } else if (this.button.offsetEnd === 'xxl') {
        return 'ExLXXl'
      } else {
        return ''
      }
    } else {
      if (this.button.offsetEnd === 'none') {
        return 'ExRNone'
      } else if (this.button.offsetEnd === 'xs') {
        return 'ExRXs'
      } else if (this.button.offsetEnd === 'sm') {
        return 'ExRSm'
      } else if (this.button.offsetEnd === 'md') {
        return 'ExRMd'
      } else if (this.button.offsetEnd === 'lg') {
        return 'ExRLg'
      } else if (this.button.offsetEnd === 'xl') {
        return 'ExRXl'
      } else if (this.button.offsetEnd === 'xxl') {
        return 'ExRXXl'
      } else {
        return ''
      }
    }
  }

  get flexClass() {
    if (this.button.flex === 0) {
      return 'fl0'
    } else if (this.button.flex === 1) {
      return 'fl1'
    } else if (this.button.flex === 2) {
      return 'fl2'
    } else if (this.button.flex === 3) {
      return 'fl3'
    }
    return ''
  }

  get styles() {
    const buttonStyles: Record<string, string|number|undefined> = {}

    buttonStyles.flexGrow = this.button.flex
    buttonStyles.cursor = 'pointer'
    buttonStyles.top = this.button.offsetTop
    buttonStyles.bottom = this.button.offsetBottom
    if (this.direction === 'rtl') {
      buttonStyles.left = this.button.offsetEnd
      buttonStyles.right = this.button.offsetStart
    } else {
      buttonStyles.left = this.button.offsetStart
      buttonStyles.right = this.button.offsetEnd
    }

    return buttonStyles
  }

  get colorStyles() {
    if (this.button.style === 'primary' || this.button.style === 'secondary') {
      return {
        backgroundColor: this.button.color,
      }
    } else {
      return {
        color: this.button.color,
      }
    }
  }

  get currentNodePath() {
    return this.parentPath + 'button'
  }

  selectNode(node, path) {
    this.$emit('onSelectNode', node, path)
  }

  mounted() {
    this.$emit('initListNode', this.currentNodePath)
  }
}
